import FDocIcon from "assets/menu-icons/FDocIcon";

// Раздел доступен только подтвержденному пользователю - по тому же правилу,
// что и "Медкарта" (restricted, см. Navigation/index.jsx и useAuth().isVerified)
const fdoc = {
  id: 'fdoc',
  type: 'group',
  restricted: true,
  visible: true,
  children: [
    {
      id: 'fdoc',
      title: 'F.Doc',
      type: 'item',
      url: '/fdoc',
      icon: FDocIcon,
      breadcrumbs: false,
      restricted: true,
    }
  ]
};

export default fdoc;
